//
//
//
//
//
//
//
//
//
//
//

import ProductIcon from '@motionelements/core/src/components/product/ProductIconShiny.vue';

export default {
  props: {
    mediaType: {
      type: String,
    },
  },
  components: {
    ProductIcon,
  },
  computed: {
    mediaTypeIcon() {
      switch (this.mediaType) {
        case 'sfx':
          return 'sfx';
        default:
          return 'music';
      }
    },
  },
};
